<template>
  <div class="container">
    <div class="banner">
      <img src="../../../assets/img/aboutCar/banner3.png" alt=""/>
      <div class="btn">代驾司机认证流程</div>
    </div>
    <div class="fiexsd" v-if="isshow" @click="toAere">常见问题</div>
    <div class="main">
      <div class="box">
        <div class="title">第<span>1</span>步</div>
        <p>
          点击<span>代驾</span>业务，选择<span>车主</span>身份，点击<span
        >立即成为车主</span
        >
        </p>
        <img src="../../../assets/img/aboutCar/pass1.png" alt=""/>
      </div>
      <div class="box">
        <div class="title">第<span>2</span>步</div>
        <p>请准备好认证资料</p>
        <p>
          所需资料：<span>身份证、</span><span>驾驶证、</span
        ><span>行驶证、</span><span>注册车辆照片</span>
        </p>
        <img src="../../../assets/img/aboutCar/pass2.png" alt=""/>
      </div>
      <div class="box">
        <div class="title">第<span>3</span>步</div>
        <p><span>确认</span>绑定车主身份<span>手机号</span></p>
        <img src="../../../assets/img/aboutCar/pass3.png" alt=""/>
      </div>
      <div class="box">
        <div class="title">第<span>4</span>步</div>
        <p>上传身份证</p>
        <img src="../../../assets/img/aboutCar/pass4.png" alt=""/>
      </div>
      <div class="box">
        <div class="title">第<span>5</span>步</div>
        <p>人脸识别验证</p>
        <img src="../../../assets/img/aboutCar/pass5.png" alt=""/>
      </div>
      <div class="box">
        <div class="title">第<span>6</span>步</div>
        <p>上传驾驶证、行驶证、注册车辆照片</p>
        <img src="../../../assets/img/aboutCar/pass6.png" alt=""/>
      </div>
      <div class="box">
        <div class="title">第<span>7</span>步</div>
        <p>
          <span
          >认证审核提交成功，系统会在2个工作日内完成审核，结果通过短信通知，请耐心等待。</span
          >
        </p>
        <img src="../../../assets/img/aboutCar/pass7.png" alt=""/>
        <div class="tip">* 以上为示例信息，具体以实际展示为准</div>
      </div>

      <div class="banner">
        <img src="../../../assets/img/aboutCar/banner5.png" alt=""/>
        <div class="btns">车主如何发布行程订单？</div>
      </div>
      <div class="box">
        <div class="title">第<span>1</span>步</div>
        <p>
          进入首页选择‘’代驾“-司机身份，发单前需完成安全任务：
          <span>1、行程录音授权 2、安全须知</span>
        </p>
        <img src="../../../assets/img/aboutCar/pass8.png" alt=""/>
      </div>
      <div class="box">
        <div class="title">第<span>2</span>步</div>
        <p>点击输入<span>起终点、出发时间、</span>可提供<span>座位数</span></p>
        <img src="../../../assets/img/aboutCar/pass9.png" alt=""/>
        <img src="../../../assets/img/aboutCar/pass10.png" alt=""/>
        <img src="../../../assets/img/aboutCar/pass11.png" alt=""/>
      </div>
      <div class="box">
        <div class="title">第<span>3</span>步</div>
        <p>点击<span>立即下单</span>进入寻找乘客页面</p>
        <img src="../../../assets/img/aboutCar/pass12.png" alt=""/>
      </div>
      <div class="border"></div>
    </div>

    <div class="cjwt" id="myid">
      <div class="title">常见问题</div>
      <h5>认证问题</h5>
      <div class="border"></div>
      <div class="qustion">
        <div
          class="box"
          v-for="(item, index) in qustion"
          :key="index"
          @click="open(index)"
        >
          <div class="Q">
            <img
              src="../../../assets/img/aboutCar/Question.png"
              alt=""
              class="icon"
            />
            <p>{{ item.Q }}</p>
            <img
              src="../../../assets/img/aboutCar/up.png"
              alt=""
              v-if="!item.isShow"
              class="down"
            />
            <img
              src="../../../assets/img/aboutCar/down.png"
              alt=""
              v-if="item.isShow"
              class="down"
            />
          </div>
          <div class="A" v-if="!item.isShow">
            <img
              src="../../../assets/img/aboutCar/answer.png"
              alt=""
              class="icon"
            />
            <p v-for="(k, j) in item.A" :key="j">{{ k }}</p>
          </div>
        </div>
      </div>

      <h5>行程费用</h5>
      <div class="border"></div>
      <div class="qustion">
        <div
          class="box"
          v-for="(item, index) in qustion2"
          :key="index"
          @click="open2(index)"
        >
          <div class="Q">
            <img
              src="../../../assets/img/aboutCar/Question.png"
              alt=""
              class="icon"
            />
            <p>{{ item.Q }}</p>
            <img
              src="../../../assets/img/aboutCar/up.png"
              alt=""
              v-if="!item.isShow"
              class="down"
            />
            <img
              src="../../../assets/img/aboutCar/down.png"
              alt=""
              v-if="item.isShow"
              class="down"
            />
          </div>
          <div class="A" v-if="!item.isShow">
            <img
              src="../../../assets/img/aboutCar/answer.png"
              alt=""
              class="icon"
            />
            <p v-for="(k, j) in item.A" :key="j">{{ k }}</p>
          </div>
        </div>
      </div>

      <h5>平台规则</h5>
      <div class="border"></div>
      <div class="qustion">
        <div
          class="box"
          v-for="(item, index) in qustion3"
          :key="index"
          @click="open3(index)"
        >
          <div class="Q">
            <img
              src="../../../assets/img/aboutCar/Question.png"
              alt=""
              class="icon"
            />
            <p>{{ item.Q }}</p>
            <img
              src="../../../assets/img/aboutCar/up.png"
              alt=""
              v-if="!item.isShow"
              class="down"
            />
            <img
              src="../../../assets/img/aboutCar/down.png"
              alt=""
              v-if="item.isShow"
              class="down"
            />
          </div>
          <div class="A" v-if="!item.isShow">
            <img
              src="../../../assets/img/aboutCar/answer.png"
              alt=""
              class="icon"
            />
            <p v-for="(k, j) in item.A" :key="j">{{ k }}</p>
          </div>
        </div>
      </div>
      <div class="toTop" v-show="totop" @click="toTop">
        <img src="../../../assets/img/aboutCar/goUp.png"/>回到顶部
      </div>
    </div>
  </div>
</template>


<script>
  import mobileType from '@/utils/mobileType';

  export default {
    data() {
      return {
        qustion: [
          {
            Q: '目前对代驾司机、车辆有什么要求？',
            A: [
              '车主：年龄18-70周岁，驾龄≥1年，准驾车型C2及以上；',
              '车辆：七座及以下小型客车，车龄＜15年；',
              '申请认证的车主驾驶证与身份证需保持一致，一个证件信息只可以认证一个账号。',
            ],
            isShow: 'false',
          },
          {
            Q: '已经是快车司机，注册代驾司机还需要再次完善车主信息么？',
            A: ['已注册的快车司机，需上传身份证、驾驶证、行驶证进行车主信息验证'],
            isShow: 'false',
          },
          {
            Q: '代驾司机如何更换注册车辆信息？',
            A: [
              '进入代驾司机端页面→点击右上角代驾中心→车主认证→修改信息，上传新的车辆信息即可；',
              '证件信息上传后在2个工作日内完成审核。'
            ],
            isShow: 'false',
          },
        ],
        qustion2: [
          {
            Q: '车费何时到账？',
            A: [
              ' 如乘客未点击“确认到达目的地”，车费在24小时后自动到达车主账户代驾账户',
            ],
            isShow: 'false',
          },
          {
            Q: '余额可以支付代驾费么？',
            A: ['可以支付，暂时仅限于代驾业务'],
            isShow: 'false',
          },
          {
            Q: '包干司机顺风车会收取平台服务费么？',
            A: [
              '目前暂时不区分包干司机身份，后期根据公司政策针 对包干司机进行相应优惠',
            ],
            isShow: 'false',
          },
          {
            Q: '网约车余额与顺风车余额属于同一账号么？',
            A: [
              '代驾司机余额和网约车余额不一致，分别走提现流程，流程暂定没有限额',
            ],
            isShow: 'false',
          },
          {
            Q: '代驾会有预估费用么？',
            A: [
              '代驾为一口价，当前预付为独享价，拼单会有优惠；如拼单失败，行程结束后预付款会按照独享价计算金额；如拼单成功，行程结束成后会返还拼单费用',
            ],
            isShow: 'false',
          },
        ],
        qustion3: [
          {
            Q: '信用值的作用是什么？最高上限多少分？',
            A: [
              '车主可按照行程实际体验进行好评、投诉、加入黑名单操作；信任值低会影响优先派单、计价规则、取消次数限制等产品体验',
              '信任值上限100分',
            ],
            isShow: 'false',
          },
          {
            Q: '什么样的情况会判定有责取消订单？有责取消有什么惩罚举措？',
            A: [
              '预约成功3分钟以内免责取消，超过3分钟后视为有责取消',
              '预约成功超过3分钟或等待接驾中，车主取消订单信任值-5分',
              '若车主迟到，乘客可免责取消',
              '乘客到达后，车主取消订单信任值-10分',
            ],
            isShow: 'false',
          },
        ],
        totop: false,
        isshow: true,
      };
    },
    mounted() {
      // 此处true需要加上，不加滚动事件可能绑定不成功
      window.addEventListener('scroll', this.handleScroll, true);
    },
    beforeDestroy() { // 在组件生命周期结束的时候销毁。
      window.removeEventListener('scroll', this.handleScroll, true);
    },
    methods: {
      open(index) {
        this.qustion[index].isShow = !this.qustion[index].isShow;
      },
      open2(index) {
        this.qustion2[index].isShow = !this.qustion2[index].isShow;
      },

      open3(index) {
        this.qustion3[index].isShow = !this.qustion3[index].isShow;
      },

      toAere(key) {
        // 获取点击的按钮对应页面的id
        var PageId = document.getElementById('myid');
        // 打印出对应页面与窗口的距离

        window.scrollTo({
          top: PageId.offsetTop,
          behavior: 'smooth',
        });
        this.isshow = false;
      },

      handleScroll() {
        var PageId = document.getElementById('myid');

        var height = document.documentElement.clientHeight;

        let scrolltop =
          document.documentElement.scrollTop || document.body.scrollTop;

        scrolltop > PageId.offsetTop ? (this.gotop = true) : (this.gotop = false);

        PageId.offsetTop < height + scrolltop
          ? (this.isshow = false)
          : (this.isshow = true);
        PageId.offsetTop < height + scrolltop
          ? (this.totop = true)
          : (this.totop = false);
      },
      //回到顶部
      toTop() {
        let top = document.documentElement.scrollTop || document.body.scrollTop;
        const timeTop = setInterval(() => {
          document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
          if (top <= 0) {
            clearInterval(timeTop);
          }
        }, 10);
      },

      openWindow() {
        let params = {
          type: 0, //业务类型
          methodName: 'authentication', //传给客户端标识方法名
          data: {
            title: '车主认证',
          }, //传多个参数给原生(为对象类型)
        };
        if (mobileType.isIOS()) {
          //vue调用iOS方法，且传值给iOS （iOS 方法名为 getDataFromVue）
          window.webkit.messageHandlers.getDataFromVue.postMessage(params);
        } else if (mobileType.isAndroid()) {
          //vue调用Android方法，且传值给Android （Android方法名为 getDataFromVue）
          window.Android.getDataFromVue(JSON.stringify(params));
        } else {
        }
      },
    },
  };
</script>
<style scoped lang="less">
  .container {
    position: relative;
    color: #333;

    .banner {
      width: 100%;
      height: 8.125rem;
      position: relative;

      img {
        width: 100%;
        height: 100%;
      }

      .btn {
        position: absolute;
        top: 2.9375rem;
        left: 0.9375rem;
        color: #fff;
        font-weight: 800;
        font-size: 1.3125rem;
        line-height: 1.625rem;
      }

      .btns {
        position: absolute;
        top: 2.9375rem;
        width: 50%;
        left: 0.9375rem;
        color: #fff;
        font-weight: 800;
        font-size: 1.3125rem;
        line-height: 1.625rem;
      }
    }

    .main {
      margin-top: 1.875rem;

      .banner {
        margin-bottom: 1.875rem;
        border-top: 0.0625rem solid #f0f1f5;
        padding-top: 0.2rem;
      }

      .box {
        margin-bottom: 2.25rem;

        .tip {
          font-size: 0.875rem;
          font-weight: 400;
          color: #999999;
          line-height: 1.375rem;
          text-align: center;
          margin-top: 0.3rem;
        }

        .title {
          background: url(../../../assets/img/aboutCar/titlebj.png);
          background-size: 100% 100%;
          height: 1.375rem;
          line-height: 1.375rem;
          width: 21.6875rem;
          margin: 0 auto;
          font-size: 0.875rem;
          font-weight: 500;
          color: #fff;
          text-indent: 0.3125rem;
          margin-bottom: 0.4375rem;

          span {
            font-weight: 800;
            margin: 0 0.25rem;
          }
        }

        p {
          width: 21.6875rem;
          margin: 0 auto;
          font-size: 0.875rem;
          font-weight: 400;
          color: #666666;
          line-height: 1.25rem;
          margin-bottom: 0.6875rem;

          span {
            color: #333;
            font-weight: 900;
          }
        }

        img {
          width: 15rem;
          margin: 0 auto;
          display: block;
        }
      }

      .border {
        border: 0.0625rem solid #f0f1f5;
        margin-bottom: 1.875rem;
      }
    }

    .fiexsd {
      width: 5.8125rem;
      height: 1.875rem;
      color: #fff;
      font-size: 0.75rem;
      line-height: 1.875rem;
      right: 0;
      position: fixed;
      top: 13.75rem;
      background: url(../../../assets/img/aboutCar/commonProblem.png);
      background-size: 100% 100%;
      text-indent: 2rem;
      z-index: 9;
    }

    .cainment {
      background: goldenrod;
      height: 70rem;
    }

    .cjwt {
      width: 100%;
      position: relative;

      .title {
        width: 21.6875rem;
        height: 2.25rem;
        line-height: 2.25rem;
        background: #ebeff7;
        border-radius: 0.3125rem;
        text-align: center;
        color: #333;
        margin: 0 auto;
        margin-bottom: 1rem;
      }

      h5 {
        padding-bottom: 0.6875rem;
        width: 21.6875rem;
        margin: 0 auto;
        color: #333333;
        line-height: 1.25rem;
        font-size: 0.875rem;
      }

      .border {
        width: 21.6875rem;
        height: 0.0625rem;
        background: #f5f7fb;
        border-radius: 0.3125rem;
        margin: 0 auto;
      }

      .qustion {
        width: 21.6875rem;
        margin: 0 auto;
        margin-bottom: 1.8125rem;

        .box {
          padding-top: 0.9375rem;
          border-bottom: 1px solid #f5f7fb;

          .Q {
            position: relative;
            padding: 0 1.5rem 0.5rem;
            font-size: 0.875rem;
            color: #333333;
            line-height: 1.25rem;

            .icon {
              position: absolute;
              top: 0rem;
              left: 0;
              width: 1rem;
              height: 1.25rem;
            }

            .down {
              position: absolute;
              top: 0.2rem;
              right: 0;
              width: 0.625rem;
              height: 0.375rem;
            }
          }

          .A {
            position: relative;
            padding: 0 1.5rem 0.5rem;
            font-size: 0.875rem;
            color: #666666;
            line-height: 1.25rem;

            .icon {
              position: absolute;
              top: 0rem;
              left: 0;
              width: 1rem;
              height: 1.25rem;
            }
          }
        }
      }

      .toTop {
        width: 5.8125rem;
        height: 1.875rem;
        position: fixed;
        top: 30rem;
        color: #fff;
        font-size: 0.75rem;
        line-height: 1.875rem;
        right: 0;
        background: url(../../../assets/img/aboutCar/goUpBackground.png);
        background-size: 100% 100%;

        img {
          width: 0.8125rem;
          height: 0.875rem;
          margin: 0.5rem;
          vertical-align: middle;
          padding-right: 0.3rem;
        }
      }
    }
  }
</style>

